import styled from 'styled-components'

const Row = styled.div`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:focus-within {
    outline: 2px solid var(--color-focus);
    outline-offset: 2px;
    border-radius: 4px;
  }
`

const Square = styled.span`
  height: 20px;
  width: 20px;
  background-color: ${p => p.active ? 'var(--color-primary)' : 'var(--color-bg-input)'};
  border: 2px solid ${p => p.active ? 'var(--color-primary)' : 'var(--color-text-secondary)'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  position: relative;

  &::after {
    content: ${p => p.active ? "'✓'" : "''"};
    color: var(--color-bg-main);
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
  }

  &:hover {
    border-color: var(--color-primary);
    ${p => !p.active && 'background-color: rgba(151, 202, 111, 0.1);'}
  }
`

const Text = styled.span`
  color: var(--color-text-primary);
  font-size: 14px;
  font-family: 'Roboto', Arial, sans-serif;
  font-weight: 500;
  user-select: none;
`

const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

const Checkbox = ({ value, label, onChange, id, name, disabled = false }) => {
  const handleChange = () => {
    if (!disabled) {
      onChange(value)
    }
  }

  return (
    <Row
      onClick={handleChange}
      style={{ opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <HiddenInput
        type="checkbox"
        checked={value}
        onChange={handleChange}
        id={id}
        name={name}
        disabled={disabled}
        aria-label={label}
      />
      <Square active={value} />
      <Text>{label}</Text>
    </Row>
  )
}

export default Checkbox
